module.exports = __webpack_public_path__ + "img/pd-img46.9fbc6d0c.jpg";